/**
 * @desc 分页
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.stockSkuPlatform.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/stock/platform/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
